module.exports = __webpack_public_path__ + "static/media/station_nyarutarama1.433a4a6c.jpeg";